import React from 'react'
import './focus.scss';
const Focus = () => {
    return (
        <>
            <section className='focus_main' id='benefits'>
                <div className='inner_focvus'>
                    <div className='custom-container'>
                        <div className='innar_last'>
   <h2>Focus on Your Product, Not Multichain Complexity</h2>
                        <div>
                            <div className='left_inner'>
                                <img src='\assets\puzz.svg' />
                                <div>
                                    <h3>Flexible Integration</h3>
                                    <p>Seamlessly integrate Aqua with APIs, SDKs, and dashboards, giving you complete control over how your dApp connects.</p>
                                </div>
                            </div>
                            <div className='left_inner'>
                                <img src='\assets\wall.svg' />
                                <div>
                                    <h3>Unified Deposits</h3>
                                    <p>Provide users with a single deposit address per session or account, simplifying the deposit process across multiple chains.</p>
                                </div>
                            </div>
                            <div className='left_inner'>
                                <img src='\assets\shie.svg' />
                                <div>
                                    <h3>Security-First Architecture</h3>
                                    <p>Protect your users with robust security measures, clear auditing trails, and reliable transaction processing.</p>
                                </div>
                            </div>
                            <div className='left_inner'>
                                <img src='\assets\wor.svg' />
                                <div>
                                    <h3>Works Everywhere</h3>
                                    <p>Support any dApp, any chain, and any token with available liquidity, without worrying about multichain complexity.</p>
                                </div>
                            </div>
                        </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    )
}

export default Focus
